module.exports = __webpack_public_path__ + "img/PorkItaly.6dec5cf6.png";